"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TEXT_ALIGN_ON_WRAP = exports.SIZE = exports.BORDER_WIDTH = void 0;
var _tokens = require("../../tokens");
const BORDER_WIDTH = exports.BORDER_WIDTH = 2;
const SIZE = exports.SIZE = {
  S: {
    fontSize: _tokens.FONT.SIZE.M,
    lineHeight: 1.34,
    padding: [9, 16],
    iconMargin: 10
  },
  M: {
    fontSize: _tokens.FONT.SIZE.M,
    lineHeight: 1.34,
    padding: [13, 20],
    iconMargin: 14
  },
  L: {
    fontSize: _tokens.FONT.SIZE.M,
    lineHeight: 1.56,
    padding: [15, 24],
    iconMargin: 18
  }
};
const TEXT_ALIGN_ON_WRAP = exports.TEXT_ALIGN_ON_WRAP = ['left', 'center', 'right'];